import React from 'react';
import { Segmented } from 'antd';
import yaml from 'js-yaml';
import './FormatSwitch.css';

/** how structured data is written out for the reader */
export type DataFormat = 'json' | 'yaml';

export const toJson = (value: unknown): string => JSON.stringify(value, null, 2) ?? '';

export const toYaml = (value: unknown): string => {
    try {
        // no anchors for repeated objects, no folding long strings: read line
        // by line (and diffed so), both would move lines that did not change
        return yaml.dump(value, { noRefs: true, lineWidth: -1 });
    } catch {
        // something YAML cannot hold — show it as JSON rather than nothing
        return toJson(value);
    }
};

const OPTIONS = [
    { label: 'JSON', value: 'json' },
    { label: 'YAML', value: 'yaml' },
];

/** the JSON / YAML switch, wherever data can be read either way */
const FormatSwitch = ({ value, onChange }: { value: DataFormat; onChange: (format: DataFormat) => void }) => (
    <Segmented
        className="nx-format-switch"
        size="small"
        options={OPTIONS}
        value={value}
        onChange={(next) => onChange(next as DataFormat)}
        aria-label="Show as"
    />
);

export default FormatSwitch;
